<template>
  <div class="StakingRules">
    <div class="mask"></div>

    <div class="popup">
      <div class="closeIcon" @click="handleClose"></div>
      <div class="nav-main">
        <div class="nav-list">
          <div
            :class="['nav-item', activeKey === item?.id && 'nav-item-active']"
            @click="handleClick(item?.id)"
            :key="index"
            v-for="(item, index) in DETAIL_LIST"
          >
            <div class="text">{{ item?.name }}</div>
          </div>
        </div>
      </div>

      <div class="content">
        <div class="content-main">
          <div
            :class="['content-main-content', `content-main-content-${type}`]"
            v-for="(item, index) in activeContent"
            :key="index"
          >
            <div
              :class="[
                item?.type === 'title' && 'title',
                item?.type === 'text' && 'text',
                item?.classname && item?.classname,
              ]"
              v-if="item?.type === 'title' || item?.type === 'text'"
              v-html="item?.content"
            ></div>

            <table :class="table" v-if="item?.type === 'table'">
              <thead>
                <tr>
                  <td
                    v-for="(item2, index2) in item?.content?.header"
                    :key="index2"
                  >
                    {{ item2 }}
                  </td>
                </tr>
              </thead>
              <tbody>
                <tr :key="index3" v-for="(item3, index3) in item?.content?.row">
                  <td :key="index4" v-for="(item4, index4) in item3">
                    {{ item4 }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { onMounted, ref } from "vue";

export const DETAIL_NAV_ENUMS = {
  Part1: "Part1",
  Part2: "Part2",
  Part3: "Part3",
};

const DETAIL_CONTENT_TYPE = {
  TITLE: "title",
  TEXT: "text",
  IMAGE: "image",
  TABLE: "table",
};

const DETAIL_LIST = [
  {
    id: DETAIL_NAV_ENUMS.Part1,
    name: "How to stake",
    content: [
      {
        type: DETAIL_CONTENT_TYPE.TITLE,
        content: "How to stake",
      },
      {
        type: DETAIL_CONTENT_TYPE.TEXT,
        content: `The staking event is divided into four different segments in which the differences would be the staking period: 6-days, 16-days, 30-days, and 60-days staking periods. The longer the staking period and the higher the rarity of the staked Yuli Gen2, the greater the rewards.<br/><br/>You can follow these steps to participate in the staking event:<br/><br/>1.Click the "+" button to explore the staking options that is available.<br/><br/>2.Choose a Yuli Gen2 from your wallet that you wish to stake. `,
      },
      {
        type: DETAIL_CONTENT_TYPE.TEXT,
        content: `Please note: If your Yuli has not been activated on the official website or is already in the purification team you will not be able to participate in the staking event.`,
        classname: "text-bold",
      },
      {
        type: DETAIL_CONTENT_TYPE.TEXT,
        content: `3.Players participating in this staking event will not only receive PassCard rewards but we will also reserve ART and experience (EXP) rewards for the duration of the staking period for Yuli Gen2. After selecting the Yuli Gen2 you want to stake, you can view the PassCard, ART, and EXP rewards available for different staking periods displayed on the page.`,
      },
      {
        type: DETAIL_CONTENT_TYPE.TEXT,
        content: `Please note: The Passcard rewards, ART, and experience rewards will be distributed after the staking period ends!`,
        classname: "text-bold",
      },
      {
        type: DETAIL_CONTENT_TYPE.TEXT,
        content: `4.Staking Yuli Gen2 in this event requires players to pay a staking fee. The staking fee required for players varies depending on the staking period.<br/><br/>5.After successfully paying the required $ARG for the staking period, you can complete the staking process.`,
      },
      {
        type: DETAIL_CONTENT_TYPE.TEXT,
        content: `Please note: Once Yuli Gen2 is staked, it cannot be unstaked before the end of the staking period, so please choose the staking period carefully!!`,
        classname: "text-bold",
      },
      {
        type: DETAIL_CONTENT_TYPE.TEXT,
        content: `6.After completing the staking, you can click on "My Staking" to view all the rewards available for staked Yuli Gen2 at the current time and the remaining time until the end of the staking period.<br/><br/>7.When the staking period ends, you need to go to the staking website and click on "Claim Yuli & Rewards" in "My Staking" to reclaim Yuli Gen2 and claim staking rewards.`,
      }
    ],
  },
  {
    id: DETAIL_NAV_ENUMS.Part2,
    name: "ARG Consumption",
    content: [
      {
        type: DETAIL_CONTENT_TYPE.TITLE,
        content: "ARG Consumption",
      },
      {
        type: DETAIL_CONTENT_TYPE.TEXT,
        content: `The required staking ARG varies depending on the staking period and the rarity of the staked Yuli Gen2. The following are the detailed rules for ARG consumption:<br/><br/>Consumption of 6 Staking Days:<br/>-2.0 Common Yuli:            1503 ARG<br/>-2.0 Uncommon Yuli:        7477 ARG<br/>-2.0 Superior Yuli:           33917 ARG<br/>-2.0 Epic Yuli:                151787 ARG<br/>-2.0 Legendary Yuli:      770231 ARG<br/><br/>Consumption of 16 Staking Days:<br/>-2.0 Common Yuli:             4007 ARG<br/>-2.0 Uncommon Yuli:       19940 ARG<br/>-2.0 Superior Yuli:            90444 ARG<br/>-2.0 Epic Yuli:                 404765 ARG<br/>-2.0 Legendary Yuli:     2053950 ARG<br/><br/>Consumption of 30 Staking Days:<br/>-2.0 Common Yuli:             7513 ARG<br/>-2.0 Uncommon Yuli:        37387 ARG<br/>-2.0 Superior Yuli:           169583 ARG<br/>-2.0 Epic Yuli:                  758935 ARG<br/>-2.0 Legendary Yuli:       3851155 ARG<br/><br/>Consumption of 60 Staking Days:<br/>-2.0 Common Yuli:             15026 ARG<br/>-2.0 Uncommon Yuli:         74774 ARG<br/>-2.0 Superior Yuli:            339166 ARG<br/>-2.0 Epic Yuli:                   517870 ARG<br/>-2.0 Legendary Yuli:       7702311 ARG`,
      },
    ],
  },
];

export default {
  props: {},
  computed: {
    ...mapState({
      init: (state) => state.global.init,
      statusBarHeight: (state) => state.global.statusBarHeight,
      languageEnv: (state) => state.global.languageEnv,
      languagePackage: (state) => state.global.languagePackage,
    }),
  },
  watch: {
    languageEnv: {
      async handler(value) {
        if (value) {
          this.localesEnv = value;
        }
      },
      immediate: true,
      deep: true,
    },
    languagePackage: {
      async handler(value) {
        if (value) {
          this.localesPackage = value;
        }
      },
      immediate: true,
      deep: true,
    },
    activeKey: {
      async handler(value) {
        if (value) {
          const content = this.handleGetActiveContent(value);
          this.activeContent = content;
        }
      },
      immediate: true,
      deep: true,
    },
  },
  setup(prop, { emit }) {
    /**语言包 - ref */
    const localesPackage = ref({});
    /**语言环境 - ref */
    const localesEnv = ref("en");

    const activeKey = ref(DETAIL_LIST[0].id);
    const activeContent = ref([]);

    onMounted(() => {
      activeKey.value = DETAIL_LIST[0].id;
    });

    /**
     * 处理点击导航栏
     */
    const handleClick = (key) => {
      if (key === activeKey.value) return;
      activeKey.value = key;
    };

    /**
     * 根据id获取内容
     * @param id
     * @returns
     */
    const handleGetActiveContent = (id) => {
      const data = DETAIL_LIST.find((item) => {
        const _id = item?.id;
        return _id === id;
      });
      const content = data?.content || [];
      return content;
    };

    /**
     * 处理关闭
     */
    const handleClose = () => {
      emit("onClose");
    };

    return {
      localesPackage,
      localesEnv,
      activeKey,
      activeContent,
      handleClick,
      handleGetActiveContent,
      handleClose,
      DETAIL_LIST,
    };
  },
};
</script>

<style lang="less" scoped>
.StakingRules {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 999;

  .mask {
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.8);
    backdrop-filter: blur(7.5px);
    top: 0;
    left: 0;
    animation: maskFade 0.1s ease-in-out;

    @keyframes maskFade {
      0% {
        background: rgba(0, 0, 0, 0);
      }
      100% {
        background: rgba(0, 0, 0, 0.8);
      }
    }
  }

  .popup {
    position: relative;
    width: 355px;
    height: 480px;
    opacity: 1;
    background-image: url("~@/assets/images/YuliApp/YuliStaking/bg_rules.png");
    background-size: 100% 100%;
    color: rgb(255, 255, 255);
    font-family: "Inter";
    display: flex;
    flex-direction: column;
    align-items: center;
    box-sizing: border-box;

    .closeIcon {
      position: absolute;
      height: 30px;
      width: 30px;
      top: 5px;
      right: 5px;
      // cursor: pointer;
    }

    .nav {
      &-main {
        margin-top: 22px;
        margin-left: 28px;
        width: 100%;
      }

      &-list {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        width: 100%;
      }

      &-item {
        width: 122px;
        height: 30px;
        margin-right: 8px;
        border-radius: 4px;
        box-sizing: content-box;
        position: relative;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;

        .text {
          // padding-right: 26px;
          color: #70abcb;
          font-size: 12px;
          font-weight: 600;
          line-height: normal;
          text-align: center;
        }

        &-active {
          background: #1e688e;

          .text {
            color: #ffffff;
            font-weight: 700;
          }

          .img {
            height: 22px;
          }
        }
      }
    }

    .content {
      width: 323px;
      height: 360px;
      margin-top: 20px;

      &-main {
        width: 100%;
        height: 380px;
        overflow: hidden;
        overflow-y: scroll;
        &::-webkit-scrollbar {
          display: none;
        }

        &-content {
          text-align: left;

          .title {
            color: #ffffff;
            font-family: "Inter";
            font-size: 16px;
            font-style: normal;
            font-weight: 500;
            line-height: 28px;
            margin-bottom: 17px;
            text-align: center;
          }

          .text {
            color: #aae1ff;
            font-family: "Inter";
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: 18px;
            margin-bottom: 18px;
            white-space: pre-wrap;

            &-bold {
              font-weight: 600;
            }
          }

          &-table {
            margin-bottom: 20px;
            overflow-x: auto;
          }

          .table {
            width: 100%;
            font-size: 13px;
            font-weight: 400;
            text-align: center;
            padding-bottom: 20px;
            line-height: 13px;

            thead {
              td {
                font-size: 13px;
                font-weight: 500;
                color: #ffffff;
                background: #7ec1ff96;
                height: 30px;
                border-right: 2px solid rgba(255, 255, 255, 0.1);

                min-width: 80px;
                &:last-child {
                  border-right: none;
                }
              }
            }

            tbody {
              td {
                padding-top: 4px;
                font-size: 13px;
                font-weight: 400;
                background: #3561a499;
                height: 30px;
                vertical-align: middle;
                line-height: 18px;
                border-right: 2px solid rgba(255, 255, 255, 0.1);

                &:last-child {
                  border-right: none;
                }
              }
              tr {
                border-top: 4px solid rgba(255, 255, 255, 0.1);
              }
            }
          }
        }
      }

      .btn {
        width: 354px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        position: absolute;
        bottom: 30px;
        left: 0;
        right: 0;
        margin: auto;
        width: 240px;
        height: 30px;
        margin-top: 0px;
        bottom: 26px;

        &-back {
          width: 160px;
          height: 38px;
          background-size: cover;
          background-position: center;
          // background-image: url("~@/assets/images/sacrifice/icon/btn_back_2.png");
          cursor: pointer;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          width: 117px;
          height: 28px;

          .text {
            color: #eae7f2;
            font-size: 18px;
            font-weight: 400;
            font-size: 15px;
          }
        }

        &-confirm {
          width: 160px;
          height: 38px;
          background-size: cover;
          background-position: center;
          // background-image: url("~@/assets/images/sacrifice/icon/btn_confirm.png");
          cursor: pointer;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          width: 118px;
          height: 28px;

          .text {
            color: #001f3b;
            font-size: 18px;
            font-weight: 500;
            font-size: 15.02px;
            font-weight: 500;
          }
        }
      }
    }
  }
}
</style>
